import script from "./VerificationRequestsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./VerificationRequestsPage.vue?vue&type=script&setup=true&lang=js"

import "./VerificationRequestsPage.vue?vue&type=style&index=0&id=e6f7f940&lang=css"

const __exports__ = script;

export default __exports__